import { systemCode, xs_languageCode } from "../..";

export function getUrlPathSeoLive(data){

    try {
        const seoSettingsLive = data?.seoSettingsLive?JSON.parse(data.seoSettingsLive):null;
        const seoSettingLiveByDefault = seoSettingsLive && (seoSettingsLive['DEFAULT'])?.[xs_languageCode];
        const seoSettingLiveBySysCode = seoSettingsLive && (seoSettingsLive[systemCode])?.[xs_languageCode];
        const pathSeoLiveByDefault = seoSettingLiveByDefault && seoSettingLiveByDefault.pn;
        const pathSeoLiveBySysCode = seoSettingLiveBySysCode && seoSettingLiveBySysCode.pn;
        return pathSeoLiveBySysCode || pathSeoLiveByDefault || seoSettingLiveBySysCode || seoSettingLiveByDefault;

    }catch(err){
        console.error(err);
    }

    return null;
}
